// utils/buildSearchString.js

// Helper to convert "510000" => "51.0000" (if 6 digits)
function formatCIP(code) {
    // If it’s exactly 6 digits, insert a dot after the first 2 digits
    if (/^\d{6}$/.test(code)) {
      return code.slice(0, 2) + '.' + code.slice(2);
    }
    return code; // fallback if it’s not 6 digits
  }
  
  export function buildSearchString(job, cipMenu = []) {
    let parts = [];
  
    // 1) onetTitle
    if (job.onetTitle) {
      parts.push(job.onetTitle.toLowerCase());
    }
  
    // 2) onetSOC (raw + formatted)
    if (job.onetSOC) {
      parts.push(job.onetSOC); // e.g., "291031"
      const formattedSOC = job.onetSOC.slice(0, 2) + '-' + job.onetSOC.slice(2);
      parts.push(formattedSOC); // e.g., "29-1031"
    }
  
    // 3) linkBLS
    if (job.linkBLS) {
      const split1 = job.linkBLS.split('ooh/');
      if (split1.length > 1) {
        let linkPart = split1[1].replace(/\.htm.*$/, '');
        linkPart = linkPart.replace(/-/g, ' ');
        linkPart = linkPart.replace(/\//g, ', ');
        parts.push(linkPart.toLowerCase());
      }
    }
  
    // 4) aligned CIP codes
    if (job.alignedCip && Array.isArray(job.alignedCip)) {
      // Build up all CIP-related strings: raw code, dotted code, CIP name
      const allCipStrings = job.alignedCip.flatMap((code) => {
        const dotted = formatCIP(code); // e.g. "51.0000"
        const match = cipMenu.find((item) => item.cipCode === code);
        // If found in cipMenu, use the CIP name (lowercased), else fallback to code
        const cipName = match ? match.cipcodeName.trim().toLowerCase() : code;
        // Return an array of each representation
        // so we can "flatten" them into the search string
        return [code.toLowerCase(), dotted.toLowerCase(), cipName];
      });
      parts.push(allCipStrings.join(' '));
    }
  
    // Join everything up
    return parts.join(' ');
  }